import type { StageProgress } from "../../infrastructure/playLogApi.js";

export type ClearRateRange = { min: number; max: number };

const EASY_COLOR = [0x4a, 0x8a, 0xb5] as const;
const HARD_COLOR = [0xc4, 0x45, 0x3a] as const;

export function clearRateRange(progressList: (StageProgress | undefined)[]): ClearRateRange | null {
  const rates = progressList
    .map((progress) => progress?.averageClearRate)
    .filter((rate): rate is number => typeof rate === "number");
  if (rates.length === 0) return null;
  return { min: Math.min(...rates), max: Math.max(...rates) };
}

export function formatClearRatePercent(clearRate: number): string {
  const percent = clearRate * 100;
  if (percent > 0 && percent < 1) return `${percent.toFixed(1)}%`;
  return `${Math.round(percent)}%`;
}

export function relativeClearRateColor(clearRate: number, range: ClearRateRange | null): string {
  const t = relativeT(clearRate, range);
  const mix = (easy: number, hard: number) => Math.round(easy + (hard - easy) * t);
  return `rgb(${mix(EASY_COLOR[0], HARD_COLOR[0])}, ${mix(EASY_COLOR[1], HARD_COLOR[1])}, ${mix(EASY_COLOR[2], HARD_COLOR[2])})`;
}

function relativeT(clearRate: number, range: ClearRateRange | null): number {
  if (!range || range.max - range.min < 0.01) return 0.5;
  return 1 - (clearRate - range.min) / (range.max - range.min);
}
